<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="73" height="62" viewBox="0 0 73 62">
        <g id="Groupe_2" data-name="Groupe 2" transform="translate(-1719.619 -53)">
            <rect id="Rectangle_39" data-name="Rectangle 39" width="73" height="11" transform="translate(1719.619 53)" />
            <rect id="Rectangle_40" data-name="Rectangle 40" width="73" height="11" transform="translate(1719.619 79)" />
            <rect id="Rectangle_41" data-name="Rectangle 41" width="73" height="11" transform="translate(1719.619 104)" />
        </g>
    </svg>
</template>

<script>
export default {
    name: "Menu",
};
</script>

<style scoped></style>
